<template>
  <v-skeleton-loader class="mensagem-optout-answer" type="image" transition="fade-transition" :loading="$apollo.queries.optout_answer_message.loading">
    <v-card class="resposta-optout">
      <v-card-title class="pb-3">
        <span class="table-card-title px-0">Resposta de descadastro</span>

        <v-tooltip right max-width="300px">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <mf-icon small class="ml-3 mb-1" color="cinza-0">info</mf-icon>
            </span>
          </template>
          <span>Neste campo deverá ser inserida a mensagem que o usuário receberá após optar por não receber mais ofertas.</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-textarea
          v-model="optout_answer_message"
          class="texto-corrido"
          :background-color="!editing ? 'cinza-l90' : null"
          :disabled="!editing"
          height="80px"
          outlined
          no-resize
          maxlength="250"
          counter="250"
        />

        <mf-action-buttons
          v-if="editing"
          :primary-button="{
            text: 'Salvar',
            action: () => save(),
            isVisible: true,
            isLoading: $wait.is('update-optout-answer-message'),
          }"
          :cancel-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
          }"
        />

        <div v-else class="d-flex justify-end py-3">
          <mf-button label="Editar" @click="startEdit" />
        </div>
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import gql from 'graphql-tag'

const QUERY_GET_MESSAGE_BY_TYPE = gql`
  query GetMessageByType {
    getMessageByType(type: OPTOUT_ANSWER) {
      _id
      type
      text
    }
  }
`
const MUTATION_UPDATE_OPTOUT_ANSWER_MESSAGE = gql`
  mutation UpdateMessageByType($text: String!) {
    updateMessageByType(type: OPTOUT_ANSWER, text: $text) {
      _id
      type
      text
    }
  }
`
export default {
  data: () => ({
    optout_answer_message: '',
    backup_optout_answer_message: '',
    editing: false,
  }),
  apollo: {
    optout_answer_message: {
      query: QUERY_GET_MESSAGE_BY_TYPE,
      update({ getMessageByType }) {
        return getMessageByType.text
      },
    },
  },
  methods: {
    startEdit() {
      this.backup_optout_answer_message = cloneDeep(this.optout_answer_message)
      this.editing = true
    },
    endEdit() {
      this.editing = false
    },
    cancel() {
      this.optout_answer_message = this.backup_optout_answer_message
      this.endEdit()
    },
    async save() {
      try {
        this.$wait.start('update-optout-answer-message')
        await this.$apollo.mutate({ mutation: MUTATION_UPDATE_OPTOUT_ANSWER_MESSAGE, variables: { text: this.optout_answer_message } })
        this.$snackbar({ message: 'Mensagem atualizada', snackbarColor: 'success' })
      } catch (error) {
        this.$snackbar({ message: 'Erro ao atualizar mensagem', snackbarColor: 'error' })
        this.cancel()
      } finally {
        this.$wait.end('update-optout-answer-message')
        this.endEdit()
      }
    },
  },
}
</script>
